import * as fromDatatype from "../datatype-library/index";


export interface bl_wms_packing_list_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    running_no: fromDatatype.VarcharDatatypeInterface;
    packer_guid: fromDatatype.GuidDataFieldInterface;
    doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    packing_date: fromDatatype.TimestampTzDatatypeInterface;
    warehouse_hdr_guid: fromDatatype.GuidDataFieldInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    reference_no: fromDatatype.VarcharDatatypeInterface;
    tracking_id: fromDatatype.VarcharDatatypeInterface;
    posting_status: fromDatatype.VarcharDatatypeInterface;
    doc_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
    delivery_entity_json: fromDatatype.JsonDatatypeInterface;
    billing_json: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    entity_branch_code : fromDatatype.VarcharDatatypeInterface;
    entity_branch_guid   : fromDatatype.GuidDataFieldInterface;
}


export class bl_wms_packing_list_hdr_RowClass
    implements bl_wms_packing_list_hdr_RowInterface {
        guid: fromDatatype.GuidDataFieldInterface;
        running_no: fromDatatype.VarcharDatatypeInterface;
        packer_guid: fromDatatype.GuidDataFieldInterface;
        doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
        packing_date: fromDatatype.TimestampTzDatatypeInterface;
        warehouse_hdr_guid: fromDatatype.GuidDataFieldInterface;
        descr: fromDatatype.VarcharDatatypeInterface;
        remarks: fromDatatype.VarcharDatatypeInterface;
        reference_no: fromDatatype.VarcharDatatypeInterface;
        tracking_id: fromDatatype.VarcharDatatypeInterface;
        posting_status: fromDatatype.VarcharDatatypeInterface;
        doc_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
        delivery_entity_json: fromDatatype.JsonDatatypeInterface;
        billing_json: fromDatatype.JsonDatatypeInterface;
        status: fromDatatype.StatusDataFieldInterface;
        created_date: fromDatatype.TimestampTzDatatypeInterface;
        updated_date: fromDatatype.TimestampTzDatatypeInterface;
        created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
        updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
        revision: fromDatatype.GuidDataFieldInterface;
        vrsn: fromDatatype.VrsnDataFieldInterface;
        property_json: fromDatatype.JsonDatatypeInterface;
        namespace: fromDatatype.VarcharDatatypeInterface;
        acl_config: fromDatatype.JsonDatatypeInterface;
        acl_policy: fromDatatype.JsonDatatypeInterface;
        entity_branch_code : fromDatatype.VarcharDatatypeInterface;
        entity_branch_guid   : fromDatatype.GuidDataFieldInterface;

}